import { render, staticRenderFns } from "./ProgressSkill.vue?vue&type=template&id=f455cf12&scoped=true&"
import script from "@/views/Users/Student/Progress/ProgressSkill.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/ProgressSkill.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/progress-skill.scss?vue&type=style&index=0&id=f455cf12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f455cf12",
  null
  
)

export default component.exports